import React, { useEffect, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Row, Select, Spin } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { APP_LOCAL_DATE_FORMAT, APP_LOCAL_DATE_FORMAT_PAYLOAD } from 'app/config/constants';
import { checkInKrQualMonth, checkInKrQualQuarter, checkInQualititativeMidYear, getKrQualCheckInMidYear, reset } from 'app/entities/checkIn/checkIn.reducer';
import { getBoxWorkStatus } from 'app/entities/common/common.reducer';
import { checkInKrQualAdjust } from 'app/entities/kr/kr-qualitative.reducer';
import ObjectiveUpdate from 'app/entities/objective/form/objective-update';
import AdjustObjectiveUpdate from 'app/entities/objective/form/objective-update-adjustment';
import { getEntity as getDetailObject } from 'app/entities/objective/objective.reducer';
import { EvaluationTypes } from 'app/shared/model/enum/evaluation-type.enum';
import { StatusType } from 'app/shared/model/enum/status.enum';
import { formatNumber, formatNumberPercent, parseNumber, parseNumberPercent } from 'app/shared/util/help';
import { displayPercent, percent } from 'app/shared/util/percent';
import { filterOption } from 'app/shared/util/select-filter';
import dayjs from 'dayjs';
import * as _ from 'lodash';
import KRUpdate from '../../kr-update';

type IReportQualitativeResult = {
  handleClose: () => void;
  krCheckIn?: any;
  handleNextData: () => void;
  hideNextKr: boolean;
};

export const ReportQualitativeResult = ({ handleClose, krCheckIn, handleNextData, hideNextKr }: IReportQualitativeResult) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const filters = useAppSelector(state => state.filters.orgCheckIn);
  const objectiveEntity = useAppSelector(state => state.objective.entity);
  const workStatusList = useAppSelector(state => state.common.workStatus);
  const entity = useAppSelector(state => state.checkIn.entity);
  const [isOpenModalFormKr, setIsOpenModalFormKr] = useState(false);
  const [isOpenModalFormObjective, setIsOpenModalFormObjective] = useState(false);
  const [isOpenAdjustmentModel, setOpenAdjustmentModel] = useState(false);
  const [isUpdating, setUpdating] = useState(false);
  const modalContentRef = useRef(null);

  // watch values form
  const workStatusMonthValues = Form.useWatch('workStatusMonth', form);
  const workStatusQuarterValues = Form.useWatch('workStatusQuarter', form);
  const progressionPointValue = Form.useWatch('progressionPoint', form);
  const qualityPointValue = Form.useWatch('qualityPoint', form);
  const purposeYearValue = Form.useWatch('purpose-0', form);
  const purposeQuarterValue = Form.useWatch('purpose-1', form);
  const purposeMonthOneValue = Form.useWatch('purpose-2', form);
  const purposeMonthTwoValue = Form.useWatch('purpose-3', form);
  const purposeMonthThreeValue = Form.useWatch('purpose-4', form);

  useEffect(() => {
    if (krCheckIn && filters) {
      form.resetFields();
      innitData();
    }
  }, [krCheckIn]);

  useEffect(() => {
    if (entity) {
      form.setFieldValue('planPeriodName', entity?.planPeriodName)
      form.setFieldValue('reportScheduleName', entity?.reportScheduleName)
      if (entity?.keyResultMonth) {
        form.setFieldValue('workStatusMonth', entity?.keyResultMonth?.workStatus)
        form.setFieldValue('completeNoteMonth', entity?.keyResultMonth?.completeNote)
        form.setFieldValue('unFinishNoteMonth', entity?.keyResultMonth?.unFinishNote)
        form.setFieldValue('completedOnMonth', entity?.keyResultMonth?.completedOn !== null ? dayjs(entity?.keyResultMonth?.completedOn) : null)
        form.setFieldValue('expectedCompleteOnMonth', entity?.keyResultMonth?.expectedCompleteOn != null ? dayjs(entity?.keyResultMonth?.expectedCompleteOn) : null)
      }
      if (entity?.keyResultQuarter) {
        form.setFieldValue('workStatusQuarter', entity?.keyResultQuarter?.workStatus)
        form.setFieldValue('completeNoteQuarter', entity?.keyResultQuarter?.completeNote)
        form.setFieldValue('unFinishNoteQuarter', entity?.keyResultQuarter?.unFinishNote)
        form.setFieldValue('completedOnQuarter', entity?.keyResultQuarter?.completedOn != null ? dayjs(entity?.keyResultQuarter?.completedOn) : null)
        form.setFieldValue('expectedCompleteOnQuarter', entity?.keyResultQuarter?.expectedCompleteOn != null ? dayjs(entity?.keyResultQuarter?.expectedCompleteOn) : null)
        form.setFieldValue('progressionPoint', entity?.keyResultQuarter?.progressionPoint !== null ? displayPercent(entity?.keyResultQuarter?.progressionPoint) : null)
        form.setFieldValue('qualityPoint', entity?.keyResultQuarter?.qualityPoint !== null ? displayPercent(entity?.keyResultQuarter?.qualityPoint) : null)
        form.setFieldValue('ratingNote', entity?.keyResultQuarter?.ratingNote)
      }
      if (entity?.adjustment) {
        form.setFieldValue('reason', entity?.adjustment?.adjustmentReason)
        form.setFieldValue('issue', entity?.adjustment?.adjustmentIssue)
        form.setFieldValue('krAdjustmentNote', entity?.adjustment?.adjustmentNote)
        form.setFieldValue('solution', entity?.adjustment?.adjustmentSolution)
      }
    }
  }, [entity]);

  useEffect(() => {
    if (qualityPointValue !== null && progressionPointValue !== null) {
      const { evaluationMethods } = entity?.keyResultQuarter || {};
      const includesProgress = evaluationMethods?.includes(EvaluationTypes.Progress);
      const includesQuality = evaluationMethods?.includes(EvaluationTypes.Quality);

      if (includesProgress && !includesQuality) {
        form.setFieldValue('finalPoint', progressionPointValue);
      } else if (includesQuality && !includesProgress) {
        form.setFieldValue('finalPoint', qualityPointValue);
      } else {
        form.setFieldValue('finalPoint', (qualityPointValue + progressionPointValue) / 2);
      }
    }
  }, [qualityPointValue, progressionPointValue]);

  useEffect(() => {
    form.validateFields(['purpose-2', 'purpose-3', 'purpose-4']);
  }, [purposeQuarterValue, purposeMonthOneValue, purposeMonthTwoValue, purposeMonthThreeValue]);


  const innitData = () => {
    dispatch(getBoxWorkStatus({ statusType: 1 }));
    dispatch(getKrQualCheckInMidYear({ krId: krCheckIn?.id, planPeriodId: filters?.planPeriodId }));
  };

  const handleOpenModalAdjustmentObjective = () => {
    setOpenAdjustmentModel(true);
  };

  const handleCloseModalAdjustmentObjective = reload => {
    setOpenAdjustmentModel(false);
    if (reload) {
      dispatch(getDetailObject(entity?.objective?.id));
    }
  };

  const MapperPayload = (values: any) => {
    const {
      workStatusMonth,
      completedOnMonth,
      expectedCompleteOnMonth,
      completeNoteMonth,
      unFinishNoteMonth,
      workStatusQuarter,
      completedOnQuarter,
      expectedCompleteOnQuarter,
      completeNoteQuarter,
      unFinishNoteQuarter,
      solution,
      reason,
      issue,
      krAdjustmentNote,
      progressionPoint,
      sendingNotification,
      qualityPoint,
      finalPoint,
      ratingNote,
      reportScheduleId,
      reportScheduleName,
      planPeriodName,
      ...remainingValues
    } = values;
    // Khởi tạo mảng khóa
    const keys = Object.keys(remainingValues);
    // Chia mảng thành các nhóm nhỏ, mỗi nhóm có 3 phần tử
    const groupedKeys = _.chunk(keys, 3);
    // Tạo mảng mới từ các nhóm khóa
    const subs = _.map(groupedKeys, group => {
      const mapper = _.map(group, key => {
        if (key.includes('startDate') || key.includes('dueDate')) {
          return dayjs(remainingValues[key]).format(APP_LOCAL_DATE_FORMAT_PAYLOAD); // Định dạng ngày theo ý muốn
        }
        return remainingValues[key];
      });
      return _.zipObject(['purpose', 'startDate', 'dueDate'], mapper);
    });
    const combinedSubs = subs.map((item, index) => {
      if (item.purpose !== null && item.purpose !== undefined) {
        return { ...item, planPeriodId: entity?.adjustment?.krApproved[index].planPeriodId };
      }
    });
    const valueMonth = {
      reportScheduleId,
      reportObjectId: krCheckIn?.id,
      planPeriodId: entity?.keyResultMonth?.planPeriodId,
      workStatus: workStatusMonth,
      completedOn: completedOnMonth && dayjs(completedOnMonth).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
      expectedCompleteOn: expectedCompleteOnMonth && dayjs(expectedCompleteOnMonth).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
      completeNote: completeNoteMonth,
      unFinishNote: unFinishNoteMonth,
    };
    const valueQuarter = {
      reportScheduleId,
      reportObjectId: krCheckIn?.id,
      planPeriodId: entity?.keyResultQuarter?.planPeriodId,
      workStatus: workStatusQuarter,
      completedOn: completedOnQuarter && dayjs(completedOnQuarter).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
      expectedCompleteOn: expectedCompleteOnQuarter && dayjs(expectedCompleteOnQuarter).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
      completeNote: completeNoteQuarter,
      unFinishNote: unFinishNoteQuarter,
      progressionPoint: percent(progressionPoint ?? 0),
      qualityPoint: percent(qualityPoint ?? 0),
      finalPoint: percent(finalPoint),
      ratingNote,
    };
    const valueAdjustment = {
      solution,
      reason,
      issue,
      krId: krCheckIn?.id,
      krAdjustmentNote,
      sendingNotification,
      subs: _.filter(combinedSubs, (o) => { return o !== null && o !== undefined }),
    };
    return { valueQuarter, valueMonth, valueAdjustment };
  };

  useEffect(() => {
    if (isUpdating) {
      handleClose();
    }
  }, [isUpdating]);

  const handleSubmit = values => {
    const { valueQuarter, valueMonth, valueAdjustment } = MapperPayload(values);
    setUpdating(true);
    dispatch(checkInQualititativeMidYear({ krId: krCheckIn?.id, isAdjustment: true, quarter: valueQuarter, month: valueMonth, adjustment: valueAdjustment }))
      .then(response => {
        const isFailed = _.some(response, (o: any) => {
          return !o.payload;
        });
        if (isFailed) return;
        form.resetFields();
        handleClose();
      })
      .catch(() => {
        return;
      })
      .finally(() => {
        setUpdating(false);
      });
  };

  const handleNextKr = () => {
    form
      .validateFields()
      .then(values => {
        const { valueQuarter, valueMonth, valueAdjustment } = MapperPayload(values);
        setUpdating(true);
        Promise.all([
          dispatch(checkInKrQualQuarter(valueQuarter)),
          dispatch(checkInKrQualMonth(valueMonth)),
          dispatch(checkInKrQualAdjust(valueAdjustment)),
        ])
          .then(response => {
            const isFailed = _.some(response, o => {
              return !o.payload;
            });
            if (isFailed) return;
            form.scrollToField('reportScheduleName');
            form.resetFields();
            dispatch(reset());
            handleNextData();
          })
          .catch(() => {
            return;
          })
          .finally(() => {
            setUpdating(false);
          });
      })
      .catch(() => {
        return;
      });
  };

  const handleEditKr = () => {
    setIsOpenModalFormKr(true);
  };

  const handleCloseModelKr = () => {
    setIsOpenModalFormKr(false);
  };

  const handleEditObjective = () => {
    setIsOpenModalFormObjective(true);
  };

  const handleCloseModelObjective = () => {
    setIsOpenModalFormObjective(false);
  };

  return (
    <Spin delay={500} spinning={isUpdating}>
      <Form ref={modalContentRef} size="large" form={form} className="fw-bold" onFinish={handleSubmit} layout="vertical">
        <Title className="fw-bold" level={2}>
          {`Báo cáo thực hiện KR ${filters?.accountableName ? filters.accountableName : ''}`}
          {/* {`Báo cáo thực hiện KR quý 2`} */}
        </Title>
        <Row>
          <Col md={5}>
            <Form.Item label="Kỳ kế hoạch" name={'planPeriodName'}>
              {/* <Input className="w-100" disabled value={filters?.planPeriodName} size="large" /> */}
              <Input className="w-100" disabled size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Kỳ báo cáo" name={'reportScheduleName'}>
              <Input size="large" className="w-100" readOnly />
            </Form.Item>
          </Col>
          {/* <Col md={1} />
          <Col>
            <div className="mt-4">
              <span className="cursor-pointer text-primary" onClick={() => handleEditKr()}>
                {`Xem chi tiết KR >`}
              </span>
              <br />
              <span className="cursor-pointer text-primary" onClick={() => handleEditObjective()}>
                {`Xem chi tiết mục tiêu >`}
              </span>
            </div>
          </Col> */}
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label="Mục tiêu">
              <TextArea rows={1} className="w-100" disabled value={objectiveEntity?.purpose ?? entity?.objective?.purpose} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item label="Lĩnh vực">
              <Input className="w-100" disabled value={objectiveEntity?.fieldName ?? entity?.objective?.fieldName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item label="Dự án">
              <Input className="w-100" disabled value={objectiveEntity?.projectName ?? entity?.objective?.projectName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label="Mảng công việc">
              <Input className="w-100" disabled value={objectiveEntity?.workTypeName ?? entity?.objective?.workTypeName} size="large" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label="Kết quả cần đạt được cả năm">
              <TextArea rows={1} className="w-100" disabled value={entity?.keyResultYear?.purpose} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Ngày bắt đầu">
              <DatePicker
                className="w-100"
                disabled
                value={dayjs(entity?.keyResultYear?.startDate)}
                placeholder="Chọn ngày bắt đầu"
                size="large"
                format={APP_LOCAL_DATE_FORMAT}
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={6}>
            <Form.Item label="Thời hạn hoàn thành">
              <DatePicker
                className="w-100"
                disabled
                value={dayjs(entity?.keyResultYear?.dueDate)}
                placeholder="Chọn thời hạn hoàn thành"
                size="large"
                format={APP_LOCAL_DATE_FORMAT}
              />
            </Form.Item>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col className="fw-bold h3" md={24}>
            THỰC HIỆN THÁNG 6
          </Col>
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label="Kết quả cần đạt được">
              <TextArea rows={1}
                disabled={entity?.keyResultMonth}
                readOnly={!entity?.keyResultMonth}
                value={entity?.keyResultMonth?.purpose}
                className="w-100"
                size="large"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Ngày bắt đầu">
              <Input
                disabled
                value={
                  entity?.keyResultMonth?.startDate ? dayjs(entity?.keyResultMonth?.startDate).format(APP_LOCAL_DATE_FORMAT) : undefined
                }
                className="w-100"
                size="large"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={6}>
            <Form.Item label="Thời hạn hoàn thành">
              <Input
                disabled
                value={entity?.keyResultMonth?.dueDate ? dayjs(entity?.keyResultMonth?.dueDate).format(APP_LOCAL_DATE_FORMAT) : undefined}
                className="w-100"
                size="large"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
        </Row>
        <Row>
          <Col md={7}>
            <Form.Item label="Tình trạng" rules={[{ required: entity?.keyResultMonth?.purpose ? true : false, message: 'Hãy chọn tình trạng' }]} name="workStatusMonth">
              <Select
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={workStatusList}
                placeholder="Chọn tình trạng"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          {workStatusMonthValues === StatusType.Completed && (
            <Col md={7}>
              <Form.Item
                label={`Ngày hoàn thành`}
                rules={[
                  {
                    required: entity?.keyResultMonth?.purpose && workStatusMonthValues === StatusType.Completed,
                    message: `Hãy chọn ngày hoàn thành`,
                  },
                ]}
                name={`completedOnMonth`}
              >
                <DatePicker
                  minDate={dayjs(entity?.keyResultMonth?.startDate)}
                  maxDate={dayjs(entity?.keyResultMonth?.dueDate)}
                  size="large"
                  format={APP_LOCAL_DATE_FORMAT} placeholder={`chọn ngày hoàn thành`} className="w-100" />
              </Form.Item>
            </Col>
          )}
          {workStatusMonthValues === StatusType.NotCompleted && (
            <Col md={7}>
              <Form.Item
                label={`Ngày hoàn thành dự kiến`}
                rules={[
                  {
                    required: entity?.keyResultMonth?.purpose && workStatusMonthValues === StatusType.NotCompleted,
                    message: `Hãy chọn ngày hoàn thành dự kiến`,
                  },
                ]}
                name={`expectedCompleteOnMonth`}
              >
                <DatePicker size="large" format={APP_LOCAL_DATE_FORMAT} placeholder={`chọn ngày hoàn thành dự kiến`} className="w-100" />
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item
              label="Đã hoàn thành"
              rules={[
                {
                  required: entity?.keyResultMonth?.purpose && workStatusMonthValues === StatusType.Completed,
                  message: `Hãy nhập nội dung đã hoàn thành`,
                },
              ]}
              name={'completeNoteMonth'}
            >
              <TextArea rows={6} placeholder="Nhập nội dung đã hoàn thành" size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item
              label="Lý do (Không hoàn thành/Tạm dừng/Hủy)"
              rules={[
                {
                  required: entity?.keyResultMonth?.purpose && workStatusMonthValues && workStatusMonthValues !== StatusType.Completed,
                  message: `Hãy nhập lý do`,
                },
              ]}
              name={'unFinishNoteMonth'}
            >
              <TextArea rows={6} placeholder="Nhập lý do" size="large" />
            </Form.Item>
          </Col>
        </Row>
        <hr />

        <Row>
          <Col className="fw-bold h3" md={24}>
            {entity?.keyResultQuarter?.name}
          </Col>
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label="Kết quả cần đạt được">
              <TextArea rows={1} className="w-100" size="large" disabled value={entity?.keyResultQuarter?.purpose} />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Ngày bắt đầu">
              <DatePicker
                className="w-100"
                disabled
                value={dayjs(entity?.keyResultQuarter?.startDate)}
                size="large"
                format={APP_LOCAL_DATE_FORMAT}
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={6}>
            <Form.Item label="Thời hạn hoàn thành">
              <DatePicker
                className="w-100"
                disabled
                value={dayjs(entity?.keyResultQuarter?.dueDate)}
                size="large"
                format={APP_LOCAL_DATE_FORMAT}
              />
            </Form.Item>
          </Col>
          <Col md={1} />
        </Row>
        <Row>
          <Col md={7}>
            <Form.Item label="Tình trạng" rules={[{ required: entity?.keyResultQuarter?.purpose ? true : false, message: 'Hãy chọn tình trạng' }]} name="workStatusQuarter">
              <Select
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={workStatusList}
                placeholder="Chọn tình trạng"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          {workStatusQuarterValues === StatusType.Completed ? (
            <Col md={7}>
              <Form.Item
                label={`Ngày hoàn thành Quý`}
                rules={[
                  {
                    required: entity?.keyResultQuarter?.purpose && workStatusQuarterValues === StatusType.Completed,
                    message: `Hãy chọn ngày hoàn thành`,
                  },
                ]}
                name={`completedOnQuarter`}
              >
                <DatePicker
                  minDate={dayjs(entity?.keyResultQuarter?.startDate)}
                  maxDate={dayjs(entity?.keyResultQuarter?.dueDate)}
                  size="large"
                  format={APP_LOCAL_DATE_FORMAT} placeholder={`chọn ngày hoàn thành`} className="w-100" />
              </Form.Item>
            </Col>
          ) : undefined}
          {workStatusQuarterValues === StatusType.NotCompleted ? (
            <Col md={7}>
              <Form.Item
                label={`Ngày hoàn thành dự kiến`}
                rules={[
                  {
                    required: entity?.keyResultQuarter?.purpose && workStatusQuarterValues === StatusType.NotCompleted,
                    message: `Hãy chọn ngày hoàn thành dự kiến`,
                  },
                ]}
                name={`expectedCompleteOnQuarter`}
              >
                <DatePicker size="large" format={APP_LOCAL_DATE_FORMAT} placeholder={`chọn ngày hoàn thành dự kiến`} className="w-100" />
              </Form.Item>
            </Col>
          ) : undefined}
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item
              label="Đã hoàn thành"
              rules={[
                {
                  required: entity?.keyResultQuarter?.purpose && workStatusQuarterValues === StatusType.Completed,
                  message: `Hãy nhập nội dung đã hoàn thành`,
                },
              ]}
              name={'completeNoteQuarter'}
            >
              <TextArea rows={6} placeholder="Nhập nội dung đã hoàn thành" size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item
              label="Lý do (Không hoàn thành/Tạm dừng/Hủy)"
              rules={[
                {
                  required: entity?.keyResultQuarter?.purpose && workStatusQuarterValues && workStatusQuarterValues !== StatusType.Completed,
                  message: `Hãy nhập lý do`,
                },
              ]}
              name={'unFinishNoteQuarter'}
            >
              <TextArea rows={6} placeholder="Nhập lý do" size="large" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col className="fw-bold" md={24}>
            Đánh giá tỷ lệ hoàn thành
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <Form.Item
              label="Tiến độ"
              rules={[
                {
                  required:
                    entity?.keyResultQuarter?.purpose && (workStatusQuarterValues === StatusType.Completed || workStatusQuarterValues === StatusType.NotCompleted) &&
                    entity?.keyResultQuarter?.evaluationMethods?.includes(EvaluationTypes.Progress),
                  message: 'Vui lòng nhập',
                },
              ]}
              name={'progressionPoint'}
            >
              <InputNumber
                step={0.01}
                precision={2}
                formatter={formatNumberPercent}
                parser={parseNumberPercent}
                className="w-100"
                disabled={!entity?.keyResultQuarter?.evaluationMethods?.includes(EvaluationTypes.Progress)}
                placeholder="Nhập tiến độ"
                size="large"
                addonAfter="%"
                min={0}
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item
              label="Chất lượng"
              rules={[
                {
                  required:
                    entity?.keyResultQuarter?.purpose && (workStatusQuarterValues === StatusType.Completed || workStatusQuarterValues === StatusType.NotCompleted) &&
                    entity?.keyResultQuarter?.evaluationMethods?.includes(EvaluationTypes.Quality),
                  message: 'Vui lòng nhập',
                },
              ]}
              name={'qualityPoint'}
            >
              <InputNumber
                step={0.01}
                precision={2}
                formatter={formatNumberPercent}
                parser={parseNumberPercent}
                className="w-100"
                disabled={!entity?.keyResultQuarter?.evaluationMethods?.includes(EvaluationTypes.Quality)}
                placeholder="Nhập chất lượng"
                size="large"
                addonAfter="%"
                min={0}
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item label="Trung bình" initialValue={0} name={'finalPoint'}>
              <InputNumber min={0} formatter={formatNumberPercent} parser={parseNumberPercent} className="w-100" disabled size="large" addonAfter="%" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item label="Ghi chú" name={'ratingNote'}>
              <Input className="w-100" placeholder="Nhập ghi chú" size="large" />
            </Form.Item>
          </Col>
        </Row>
        <hr />

        <Row>
          <Col className="fw-bold h3" md={24}>
            {`ĐIỀU CHỈNH KẾ HOẠCH NĂM ${entity?.adjustment?.year}`}
          </Col>
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label="Nội dung mục tiêu">
              <TextArea rows={1} className="w-100" disabled value={objectiveEntity?.purpose ?? entity?.adjustment?.objective?.purpose} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item label="Lĩnh vực">
              <Input
                className="w-100"
                disabled
                value={objectiveEntity?.fieldName ?? entity?.adjustment?.objective?.fieldName}
                size="large"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item label="Dự án">
              <Input
                className="w-100"
                disabled
                value={objectiveEntity?.projectName ?? entity?.adjustment?.objective?.projectName}
                size="large"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label="Mảng công việc">
              <Input
                className="w-100"
                disabled
                value={objectiveEntity?.workTypeName ?? entity?.adjustment?.objective?.workTypeName}
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Form.Item>
            <span className="cursor-pointer text-primary" onClick={() => handleOpenModalAdjustmentObjective()}>
              {`> Điều chỉnh mục tiêu`}
            </span>
          </Form.Item>
        </Row>
        <Row>
          <Col md={13}>
            <Row>
              <Col md={2} />
              <Col md={1} />
              <Col className="fw-bold h3" md={18}>
                KR đã duyệt
              </Col>
            </Row>
            <Row className='d-flex align-items-center gap-2'>
              <Col className="fw-bold h3" md={2}></Col>
              <Col md={12}>Kết quả cần đạt được</Col>
              <Col md={4}>Ngày bắt đầu</Col>
              <Col md={5}>Thời hạn hoàn thành</Col>
            </Row>
            {entity?.adjustment?.krApproved?.map((x, index) => {
              return (
                <Row key={`approve-${index}`} className="mt-2 d-flex align-items-center gap-2">
                  <Col md={2}>
                    <span className="fw-bold">{x.name}</span>
                    {/* <Form.Item label={`KQ cần đạt được cả ${x.name}`}>
                      <Input disabled className="w-100" value={x.purpose} size="large" />
                    </Form.Item> */}
                  </Col>
                  <Col md={12}>
                    <Form.Item>
                      <TextArea rows={1} disabled title={x.purpose} className="w-100" value={x.oldPurpose} size="large" />
                    </Form.Item>
                  </Col>
                  <Col md={4}>
                    <Form.Item>
                      <Input disabled className="w-100" value={dayjs(x.oldStartDate).format(APP_LOCAL_DATE_FORMAT)} size="large" />
                    </Form.Item>
                  </Col>
                  <Col md={5}>
                    <Form.Item>
                      <Input disabled className="w-100" value={dayjs(x.oldDueDate).format(APP_LOCAL_DATE_FORMAT)} size="large" />
                    </Form.Item>
                  </Col>
                </Row>
              );
            })}
          </Col>
          <Col md={11}>
            <Row>
              <Col className="fw-bold h3" md={18}>
                KR điều chỉnh
              </Col>
            </Row>
            <Row className="d-flex align-items-center gap-2">
              <Col md={13}>Kết quả cần đạt được</Col>
              <Col md={5}>Ngày bắt đầu</Col>
              <Col md={5}>Thời hạn hoàn thành</Col>
            </Row>
            {entity?.adjustment?.krApproved?.map((x, index) => {
              return (
                <Row className="mt-2 d-flex align-items-center gap-2" key={`adjust-${index}`}>
                  <Col md={13}>
                    <Form.Item
                      rules={[
                        {
                          required:
                            (index === 2 || index === 3 || index === 4)
                              ? purposeQuarterValue &&
                              !purposeMonthOneValue &&
                              !purposeMonthTwoValue &&
                              !purposeMonthThreeValue
                              : undefined,
                          message: 'Vui lòng nhập',
                        },
                      ]}
                      initialValue={x.purpose}
                      name={`purpose-${index}`}
                    >
                      <TextArea rows={1} title={x.purpose} className="w-100" size="large" />
                    </Form.Item>
                  </Col>
                  <Col md={5}>
                    <Form.Item initialValue={dayjs(x.startDate)} name={`startDate-${index}`}>
                      <DatePicker allowClear={false} className="w-100" format={APP_LOCAL_DATE_FORMAT} size="large" />
                    </Form.Item>
                  </Col>
                  <Col md={5}>
                    <Form.Item initialValue={dayjs(x.dueDate)} name={`dueDate-${index}`}>
                      <DatePicker allowClear={false} className="w-100" format={APP_LOCAL_DATE_FORMAT} size="large" />
                    </Form.Item>
                  </Col>
                </Row>
              );
            })}
          </Col>
        </Row>
        <Row>
          <Col md={24}>
            <Form.Item
              label="Lý do điều chỉnh kế hoạch"
              rules={[{ required: entity?.adjustment?.krApproved[0]?.purpose !== purposeYearValue, message: 'Vui lòng nhập lý do' }]}
              name={'reason'}
            >
              <Input className="w-100" size="large" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label="Khó khăn & nguyên nhân" name={'issue'}>
              <TextArea rows={6} placeholder="Nhập khó khăn & nguyên nhân" size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item label="Giải pháp và kiến nghị" name={'solution'}>
              <TextArea rows={6} placeholder="Nhập giải pháp và kiến nghị" size="large" />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col md={24}>
            <Form.Item label="Tài liệu đính kèm về kết quả thực hiện (link)" name={'krAdjustmentNote'}>
              <TextArea placeholder="Nhập tài liệu đính kèm về kết quả thực hiện" size="large" />
            </Form.Item>
            <Form.Item valuePropName="checked" name={'sendingNotification'}>
              <Checkbox>Gửi thông báo đến người nhận</Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Row className="d-flex gap-3 mt-3" justify="end">
            {!hideNextKr && (
              <Col>
                <Button
                  className="green"
                  onClick={() => {
                    handleNextKr();
                  }}
                  disabled={isUpdating}
                >
                  Lưu & Chuyển sang check in KR khác
                </Button>
              </Col>
            )}
            <Col>
              <Button
                className="secondary"
                onClick={() => {
                  handleClose();
                }}
              >
                Hủy
              </Button>
            </Col>
            <Col>
              <Button className="primary" htmlType="submit" disabled={isUpdating}>
                Lưu
              </Button>
            </Col>
          </Row>
        </Form.Item>
        {isOpenAdjustmentModel && (
          <AdjustObjectiveUpdate isOpen={isOpenAdjustmentModel} onClose={handleCloseModalAdjustmentObjective} id={entity?.objective?.id} />
        )}
        {isOpenModalFormObjective && (
          <ObjectiveUpdate isOpen={isOpenModalFormObjective} id={entity?.objective?.id} onClose={handleCloseModelObjective} />
        )}
        {isOpenModalFormKr && (
          <KRUpdate
            isOpen={isOpenModalFormKr}
            idKrBaseSelected={krCheckIn?.id}
            idObjective={entity?.objective?.id}
            krTypeRequest={krCheckIn?.krType}
            planPeriodType={filters?.planPeriodType}
            planPeriodIdSelected={filters?.planPeriodId}
            onClose={handleCloseModelKr}
          />
        )}
      </Form>
    </Spin>
  );
};

export default ReportQualitativeResult;
